const animation = weex.requireModule('animation')

export class Transition {
  static Create() {
    return new Transition()
  }

  static Default() {
    return this.Create()
      .duration(360)
      .delay(0)
      .needLayout(false)
      .timing('cubic-bezier(0.25, 0.46, 0.45, 0.94)')
  }

  constructor() {
    this.options = {}
    this.styles = {}
    this.configureTransform = []
  }

  width(width) {
    this.styles.width = `${width}px`
    return this
  }

  height(height) {
    this.styles.height = `${height}px`
    return this
  }

  backgroundColor(color) {
    this.styles.backgroundColor = color
    return this
  }

  opacity(opacity) {
    this.styles.opacity = opacity
    return this
  }

  translate(x, y, z) {
    this.configureTransform.push(`translate(${x},${y},${z})`)
    return this
  }

  translateX(x) {
    this.configureTransform.push(`translateX(${x})`)
    return this
  }

  translateY(y) {
    this.configureTransform.push(`translateY(${y})`)
    return this
  }

  rotate(x, y, z) {
    this.configureTransform.push(`rotate(${x}deg,${y}deg,${z}deg)`)
    return this
  }

  rotateX(x) {
    this.configureTransform.push(`rotateX(${x}deg)`)
    return this
  }

  rotateY(y) {
    this.configureTransform.push(`rotateY(${y}deg)`)
    return this
  }

  rotateZ(z) {
    this.configureTransform.push(`rotateZ(${z}deg)`)
    return this
  }

  perspective(pers) {
    this.configureTransform.push(`perspective(${pers})`)
    return this
  }

  scale(x, y, z) {
    this.configureTransform.push(`scale(${x},${y},${z})`)
    return this
  }

  scaleX(x) {
    this.configureTransform.push(`scaleX(${x})`)
    return this
  }

  scaleY(y) {
    this.configureTransform.push(`scaleY(${y})`)
    return this
  }

  transformOrigin(origin) {
    this.styles.transformOrigin = origin
    return this
  }

  duration(duration) {
    this.options.duration = duration
    return this
  }

  delay(delay) {
    this.options.delay = delay
    return this
  }

  needLayout(layout) {
    this.options.needLayout = layout
    return this
  }

  timing(timing) {
    this.options.timingFunction = timing
    return this
  }

  run(element, func) {
    const styles = { ...this.styles }
    if (this.configureTransform.length) {
      styles.transform = this.configureTransform.join(' ')
    }
    const opts = Object.assign({}, this.options, { styles })
    animation.transition(element, opts, func)
  }
}



// WEBPACK FOOTER //
// ./packages/utils/transition.js